import React from 'react';
import PropTypes from 'prop-types';
// Styles
import { Wrapper, Heading, Segmented, Rail } from './Toolbar.styles';

export const SORTS = [
  { id: 'popular', label: 'Popular' },
  { id: 'az', label: 'A → Z' },
  { id: 'za', label: 'Z → A' },
  { id: 'rating', label: 'Top rated' },
  { id: 'newest', label: 'Newest' }
];

const LETTERS = ['#', ...'ABCDEFGHIJKLMNOPQRSTUVWXYZ'.split('')];

const Toolbar = ({ eyebrow, title, count, sort, setSort, letters }) => (
  <Wrapper>
    <div className='top'>
      <Heading>
        <span>{eyebrow}</span>
        <h2>{title}</h2>
        {count}
      </Heading>
      <Segmented role='radiogroup' aria-label='Sort movies'>
        {SORTS.map(option => (
          <button
            key={option.id}
            type='button'
            role='radio'
            aria-checked={sort === option.id}
            className={sort === option.id ? 'active' : ''}
            onClick={() => setSort(option.id)}
          >
            {option.label}
          </button>
        ))}
      </Segmented>
    </div>
    {letters && (
      <Rail aria-label='Jump to letter'>
        {(sort === 'za' ? [...LETTERS].reverse() : LETTERS).map(letter =>
          letters.has(letter) ? (
            <a
              key={letter}
              href={`#letter-${letter === '#' ? 'num' : letter}`}
              onClick={event => {
                event.preventDefault();
                const el = document.getElementById(
                  `letter-${letter === '#' ? 'num' : letter}`
                );
                el && el.scrollIntoView({ behavior: 'smooth', block: 'start' });
              }}
            >
              {letter}
            </a>
          ) : (
            <span key={letter} aria-hidden='true'>
              {letter}
            </span>
          )
        )}
      </Rail>
    )}
  </Wrapper>
);

Toolbar.propTypes = {
  eyebrow: PropTypes.string,
  title: PropTypes.node,
  count: PropTypes.node,
  sort: PropTypes.string,
  setSort: PropTypes.func,
  letters: PropTypes.instanceOf(Set)
};

export default Toolbar;
